
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.99.66c-.434-.875-1.692-.886-2.13 0L6.439 5.575l-5.421.79C.045 6.504-.345 7.704.36 8.39l3.922 3.822-.928 5.398c-.167.976.861 1.707 1.722 1.25l4.85-2.548 4.85 2.549c.86.453 1.888-.275 1.72-1.25l-.927-5.4 3.922-3.821c.705-.687.316-1.885-.657-2.026l-5.42-.79L10.99.66z","fill":"currentColor"}})])
          )
        }
      }
    